export const FIELD = "h-12 w-full rounded-none border-0 border-b border-white/15 bg-transparent px-0 text-base text-white shadow-none placeholder:text-slate-600 focus:ring-0 focus-visible:border-volt focus-visible:ring-0 focus-visible:ring-offset-0 transition-colors";

export const Field = ({ label, htmlFor, required, children, className = "" }) => (
  <div className={className}>
    <label htmlFor={htmlFor} className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
      {label} {required && <span className="text-signal">*</span>}
    </label>
    {children}
  </div>
);
